import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';
import { IIcon } from '../icon/icon.interface';

@Component({
  selector: 'app-link',
  templateUrl: 'link.component.html',
  styleUrls: ['link.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent implements OnInit {
  @Input() label: string;
  @Input() href: string;
  @Input() openInNewTab: boolean;
  @Input() icon: IIcon;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: any;

  constructor() {}

  ngOnInit() {}
}
